/**
 * Renuvella · landing de producto
 *
 * Sin librerias, sin localStorage, sin sessionStorage.
 *
 *   [data-rnv-reveal="lineas"]   las cinco lineas del reconocimiento
 *   [data-rnv-reveal="timeline"] la linea vertical y los puntos
 *   [data-rnv-barra]             la rotacion de la barra superior
 *
 * El estado inicial atenuado lo aplica la clase .rnv-js que se agrega en el
 * <head>, asi que sin JS la pagina se lee completa. Ver snippets/rnv-head.liquid.
 */

var RNV_MENOS_MOVIMIENTO =
  window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/* --- Barra superior: rota entre los mensajes --- */
(function () {
  'use strict';

  if (RNV_MENOS_MOVIMIENTO) return;

  Array.prototype.forEach.call(document.querySelectorAll('[data-rnv-barra]'), function (barra) {
    var mensajes = barra.querySelectorAll('.rnv-barra__mensaje');
    if (mensajes.length < 2) return;

    var intervalo = parseInt(barra.getAttribute('data-intervalo'), 10) || 5000;
    var i = 0;

    setInterval(function () {
      // En una pestana de fondo no tiene sentido gastar repintados.
      if (document.hidden) return;
      mensajes[i].classList.remove('is-on');
      i = (i + 1) % mensajes.length;
      mensajes[i].classList.add('is-on');
    }, intervalo);
  });
})();

/* --- Popup de promocion ---
 *
 * Una vez por sesion, con una variable en memoria: sin cookies y sin storage.
 * Recargar la pagina lo vuelve a habilitar, y ese es el costo de no rastrear.
 *
 * Nunca aparece si el bloque de planes esta a la vista: si ya esta decidiendo,
 * interrumpirla es contraproducente.
 */
(function () {
  'use strict';

  var popup = document.querySelector('[data-rnv-popup]');
  if (!popup || typeof popup.showModal !== 'function') return;

  var yaAparecio = false;

  function planesALaVista() {
    var oferta = document.getElementById('rnv-oferta');
    if (!oferta) return false;
    var r = oferta.getBoundingClientRect();
    return r.top < window.innerHeight && r.bottom > 0;
  }

  function abrir() {
    if (yaAparecio || popup.open || planesALaVista()) return;
    yaAparecio = true;
    popup.showModal();
  }

  var cerrar = popup.querySelector('[data-rnv-popup-cerrar]');
  if (cerrar) cerrar.addEventListener('click', function () { popup.close(); });

  // Clic en el fondo. Escape ya lo maneja el <dialog> nativo.
  popup.addEventListener('click', function (ev) {
    if (ev.target === popup) popup.close();
  });

  var disparador = popup.getAttribute('data-disparador') || 'salida';

  // La intencion de salida no existe en tactil: ahi se cae al temporizador,
  // si no el popup nunca aparece en mobile, que es donde esta el trafico.
  var hayPuntero = window.matchMedia && window.matchMedia('(hover: hover)').matches;
  if (disparador === 'salida' && !hayPuntero) disparador = 'tiempo';

  if (disparador === 'salida') {
    document.addEventListener('mouseout', function (ev) {
      if (!ev.relatedTarget && ev.clientY <= 0) abrir();
    });
  } else if (disparador === 'tiempo') {
    var segundos = parseInt(popup.getAttribute('data-segundos'), 10) || 30;
    setTimeout(abrir, segundos * 1000);
  } else {
    var meta = parseInt(popup.getAttribute('data-scroll'), 10) || 45;
    var pendiente = false;

    function revisar() {
      pendiente = false;
      var alto = document.documentElement.scrollHeight - window.innerHeight;
      if (alto <= 0) return;
      if ((window.scrollY / alto) * 100 >= meta) abrir();
    }

    window.addEventListener('scroll', function () {
      if (yaAparecio || pendiente) return;
      pendiente = true;
      window.requestAnimationFrame(revisar);
    }, { passive: true });
  }
})();

/* --- Las dos animaciones de la landing --- */
(function () {
  'use strict';

  var objetivos = document.querySelectorAll('[data-rnv-reveal]');
  if (!objetivos.length) return;

  var encender = function (el) {
    el.classList.add('is-on');
  };

  // Sin soporte de IntersectionObserver, se muestra todo de una.
  if (!('IntersectionObserver' in window)) {
    Array.prototype.forEach.call(objetivos, encender);
    return;
  }

  var observador = new IntersectionObserver(
    function (entradas) {
      entradas.forEach(function (entrada) {
        if (!entrada.isIntersecting) return;
        encender(entrada.target);
        observador.unobserve(entrada.target);
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.15 }
  );

  Array.prototype.forEach.call(objetivos, function (el) {
    observador.observe(el);
  });
})();

/* ---------------------------------------------------------------------------
   Carrusel de la formula.

   El desplazamiento lo hace el navegador con scroll-snap. Este bloque solo
   agrega las flechas de escritorio, donde no hay gesto de arrastre que
   insinue que la fila sigue. Sin este archivo el carrusel funciona igual con
   el dedo, la rueda y el teclado: el contenedor es enfocable.
--------------------------------------------------------------------------- */
(function () {
  var carril = document.querySelector('[data-rnv-carrusel]');
  if (!carril) return;

  var botones = document.querySelectorAll('[data-rnv-carrusel-ir]');
  if (!botones.length) return;

  function paso() {
    var item = carril.firstElementChild;
    if (!item) return carril.clientWidth;
    // El ancho de una tarjeta mas el hueco: asi cada clic avanza exactamente
    // una posicion de snap y nunca deja una tarjeta cortada.
    var hueco = parseFloat(getComputedStyle(carril).columnGap) || 0;
    return item.getBoundingClientRect().width + hueco;
  }

  function actualizar() {
    var fin = carril.scrollWidth - carril.clientWidth;
    Array.prototype.forEach.call(botones, function (b) {
      var dir = parseInt(b.getAttribute('data-rnv-carrusel-ir'), 10);
      // 2px de tolerancia: el scroll fraccionario de los navegadores nunca
      // llega al valor exacto y el boton quedaria activo para siempre.
      b.disabled = dir < 0 ? carril.scrollLeft <= 2 : carril.scrollLeft >= fin - 2;
    });
  }

  Array.prototype.forEach.call(botones, function (b) {
    b.addEventListener('click', function () {
      var dir = parseInt(b.getAttribute('data-rnv-carrusel-ir'), 10);
      carril.scrollBy({ left: paso() * dir, behavior: 'smooth' });
    });
  });

  carril.addEventListener('scroll', actualizar, { passive: true });
  window.addEventListener('resize', actualizar);
  actualizar();
})();

/* ---------------------------------------------------------------------------
   Aviso flotante con cuenta regresiva.

   El limite viene calculado del servidor como fecha absoluta, junto con la
   hora del servidor en ese momento. Lo primero que hace este bloque es medir
   el desfase entre el reloj del servidor y el del dispositivo, y descontar
   siempre contra el del servidor. Un telefono con la hora mal puesta no
   cambia lo que dice el aviso, que es justo lo que hay que garantizar cuando
   se anuncia un plazo.

   Cuando el plazo se acaba, el aviso desaparece. No se reinicia. Esa es la
   diferencia entre un plazo y un truco.
--------------------------------------------------------------------------- */
(function () {
  'use strict';

  var aviso = document.querySelector('[data-rnv-urgente]');
  if (!aviso) return;

  var reloj = aviso.querySelector('[data-rnv-urgente-reloj]');
  var cerrar = aviso.querySelector('[data-rnv-urgente-cerrar]');
  var modo = aviso.getAttribute('data-modo');

  // El desfase se calcula con el sufijo de zona que emitio el servidor, para
  // que "las 14:00" sean las 14:00 de la tienda y no las del visitante.
  var desfase = aviso.getAttribute('data-desfase') || '';
  var conZona = aviso.getAttribute('data-limite');
  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(conZona) && desfase) {
    // -0400 se convierte en -04:00, que es lo que exige el estandar.
    conZona += desfase.replace(/^([+-]\d{2})(\d{2})$/, '$1:$2');
  }

  var limite = Date.parse(conZona);
  if (isNaN(limite)) return;

  var servidor = parseInt(aviso.getAttribute('data-servidor'), 10) * 1000;
  var salto = isNaN(servidor) ? 0 : servidor - Date.now();

  function restante() {
    return limite - (Date.now() + salto);
  }

  // El corte de despacho que ya paso vale para el dia habil siguiente. La
  // fecha limite que ya paso, en cambio, no vuelve: el aviso no se dibuja.
  if (restante() <= 0) {
    if (modo !== 'corte') return;
    limite += 24 * 60 * 60 * 1000;
  }

  function texto(ms) {
    var total = Math.floor(ms / 1000);
    var h = Math.floor(total / 3600);
    var m = Math.floor((total % 3600) / 60);
    if (h >= 1) return h + 'h ' + m + 'min';
    if (m >= 1) return m + ' min';
    return 'menos de un minuto';
  }

  var tic = null;

  function latir() {
    var ms = restante();
    if (ms <= 0) {
      aviso.hidden = true;
      if (tic) clearInterval(tic);
      return;
    }
    reloj.textContent = texto(ms);
  }

  var visible = false;
  var descartado = false;

  function mostrar() {
    if (visible || descartado) return;
    visible = true;
    aviso.hidden = false;
    // Un cuadro que se anima al entrar se ve; uno que aparece de golpe se
    // confunde con un error de carga.
    requestAnimationFrame(function () {
      aviso.classList.add('is-on');
    });
    latir();
    tic = setInterval(latir, 15000);
  }

  var umbral = (parseInt(aviso.getAttribute('data-aparecer'), 10) || 25) / 100;

  function alMover() {
    var alto = document.documentElement.scrollHeight - window.innerHeight;
    if (alto <= 0 || window.scrollY / alto >= umbral) {
      mostrar();
      window.removeEventListener('scroll', alMover);
    }
  }

  window.addEventListener('scroll', alMover, { passive: true });
  alMover();

  if (cerrar) {
    cerrar.addEventListener('click', function () {
      descartado = true;
      aviso.classList.remove('is-on');
      if (tic) clearInterval(tic);
      // Se espera a que termine la transicion antes de sacarlo del flujo,
      // para que no desaparezca de golpe.
      setTimeout(function () {
        aviso.hidden = true;
      }, 220);
    });
  }
})();
